(function GeneratorReport($, Adzuki)
{
	"use strict";

	var loaded_what_data      = {},
	    load_franchises_jqxhr = null,
	    specific_hotels       = [];

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/GeneratorReports/manageSavedReports/', function onload()
		{
			var link = $(".generated_report_id");

			link.on('click', function loadReport(e)
			{
				var report_id = $(this).data('report-id'),
					url       = '/GeneratorReports/registerSession/' + report_id;

				e.preventDefault();

				Adzuki.Ajax.get(url).then(function registerSessionAndLoadReport(response)
				{
					if (response.status === true) {
						window.location.href = Adzuki.base_uri + '/GeneratorReports/reportResults';
					} else {
						Adzuki.StatusMessage(null, 'There was an issue pulling this report. Please try again later.', 'There was an issue');
					}
				});
			});
		});

		Adzuki.onload('/GeneratorReports/reportResults/', function onload()
		{
			$('.expand-passenger-details').on('click', function loadReport(e)
			{
				var url = $(this).data('url');

				e.preventDefault();

				Adzuki.Ajax.post(url).then(function guestList(response)
				{
					let $modal = $('.modal');
					$modal.find('.modal-title').text('Primary Client and Guests');
					$modal.find('.modal-body').html(response);
					$modal.modal('show');
				});
			});
		});

		Adzuki.onload('/GeneratorReports/index/', function onload()
		{
			var saved_reports     = $(".saved-reports"),
				who_container     = $(".who-container"),
				what_container    = $(".what-container"),
				when_container    = $(".when-container"),
				display_container = $(".display-container"),
				cruise_line_ids   = [],
				ship_ids          = [];

			// onload
			getAgents();

			// if there is more than one who type, you're in admin view, change from 'hidden' to 'radio'
			if ($(".who_type").length > 1) {
				$(".who_type").each(function changeFieldType() {
					$(this).attr("type", "radio");
				});

				Adzuki.Typeahead(
					'.who_franchise_search',
					'/Franchises/search',
					function select(item) {
						$(".franchise_id").val(item.id);

						showAgentsForFranchise(item.id, true);
					}
				);
			}

			// ability to search and select specific hotel properties to report on
			Adzuki.Typeahead(
				'#reportgenerator-what_travel_type_hotel_location_description',
				'/Searches/hotelSearch/',
				function select(item, $self, typeahead) {
					specific_hotels.push({
						id  : item.id,
						name: item.name
					});

					refreshSpecificHotels();

					// clear typeahead input
					$self.val('');
				},
				null,
				// exclude ids that have already been selected
				function matcher(item) {
					var selected_hotel_ids = [];

					$.each(specific_hotels, function iterator(i, hotel) {
						selected_hotel_ids.push(hotel.id);
					});

					if (selected_hotel_ids.indexOf(item.id) < 0) {
						return item.id;
					}
				}
			);

			// saved reports
			saved_reports.on('change', function getReportId(e)
			{
				var report_id   = $(this).val();

				if (report_id !== "") {
					loadSavedReport(report_id);
				}
			});

			// "Who" section
			who_container.on('change', '.agent_ids', function getAgentIds()
			{
				// nothing to do
			});

			who_container.on('change', '.who_type', function showHideWhoOptions()
			{
				$("#single_franchise_criteria").toggleClass("hidden");
				$("#multi_franchise_criteria").toggleClass("hidden");
			});

			who_container.on('change', '.who_categories, .who_statuses, .who_types, .who_star_levels, .who_incentive_levels, .who_locations, .who_regions', Adzuki.Debounce(function onChange()
			{
				loadFranchises();
			}, 1000));

			// did a second listener just for the training training-date dates
			who_container.on('blur', '.training-date', function validateDates()
			{
				var type             = $(".training-start-date:checked").val(),
					s_date           = $(".training-date.sdate"),
					s_date_split     = s_date.val().split("/"),
					s_date_formatted = s_date_split[1] + "-" + s_date_split[0] + "-01",
					e_date           = $(".training-date.edate"),
					e_date_split     = e_date.val().split("/"),
					e_date_formatted = e_date_split[1] + "-" + e_date_split[0] + "-01",
					math             = 0;

				switch (type) {
					case "specific":
						break;
					case "range":
						math = new Date(e_date_formatted) - new Date(s_date_formatted);
						if (math < 0) {
							alert("'To' Date cannot be before 'From' date");
							e_date.closest("div").addClass("has-error");
						} else {
							e_date.closest("div").removeClass("has-error");
						}
						break;
					default:
						break;
				}
				loadFranchises();
			});

			who_container.on('change', '.training-start-date', function showDateFields()
			{
				var date_type = $(this).val();

				switch (date_type) {
					case "specific":
						$(".training-date-specific").removeClass("hidden");
						$(".training-date-range").addClass("hidden");
						break;
					case "range":
						$(".training-date-specific").addClass("hidden");
						$(".training-date-range").removeClass("hidden");
						break;
					default:
						$(".training-date-specific").addClass("hidden");
						$(".training-date-range").addClass("hidden");
						break;
				}
				loadFranchises();
			});

			// did a third listener just for the commencement commencement-date dates
			who_container.on('blur', '.commencement-date', function validateDates()
			{
				var type             = $(".commencement-start-date:checked").val(),
					s_date           = $(".commencement-date.sdate"),
					s_date_split     = s_date.val().split("/"),
					s_date_formatted = s_date_split[1] + "-" + s_date_split[0] + "-01",
					e_date           = $(".commencement-date.edate"),
					e_date_split     = e_date.val().split("/"),
					e_date_formatted = e_date_split[1] + "-" + e_date_split[0] + "-01",
					math             = 0;

				switch (type) {
					case "specific":
						break;
					case "range":
						math = new Date(e_date_formatted) - new Date(s_date_formatted);
						if (math < 0) {
							alert("'To' Date cannot be before 'From' date");
							e_date.closest("div").addClass("has-error");
						} else {
							e_date.closest("div").removeClass("has-error");
						}
						break;
					default:
						break;
				}
				loadFranchises();
			});

			who_container.on('change', '.commencement-start-date', function showDateFields()
			{
				var date_type = $(this).val();

				switch (date_type) {
					case "specific":
						$(".commencement-date-specific").removeClass("hidden");
						$(".commencement-date-range").addClass("hidden");
						break;
					case "range":
						$(".commencement-date-specific").addClass("hidden");
						$(".commencement-date-range").removeClass("hidden");
						break;
					default:
						$(".commencement-date-specific").addClass("hidden");
						$(".commencement-date-range").addClass("hidden");
						break;
				}
				loadFranchises();
			});

			// "What" Section
			what_container.on('change', '.what-all-checkbox', function showWhatTypes()
			{
				var checkbox = $(this);

				if (checkbox.is(':checked')) {
					what_container.find('.what-type').each(function hideCheckboxes()
					{
						var travel_type_checkbox = $(this).find('.what-travel-type').first();

						$(this).addClass('hidden');

						travel_type_checkbox.attr('checked', false).trigger('change');
					});
				} else {
					what_container.find('.what-type').each(function showCheckboxes()
					{
						$(this).removeClass('hidden');
					});
				}
			});

			// travel types
			what_container.on('change', '.what-type > .what-travel-type', function toggleWhatType()
			{
				var checkbox                     = $(this);
				var container                    = checkbox.closest('.what-type');
				var skip_travel_type             = false;
				var travel_types_without_options = [
					'addons', 'attraction', 'baggage', 'equipment',
					'event', 'parking', 'rail', 'visa'
				];

				$.each(travel_types_without_options, function onEachTravelType(i, travel_type) {
					if (container.hasClass(travel_type)) {
						skip_travel_type = true;
						return false;
					}
				});

				// nothing to show if the clicked checkbox is one of the
				// travel types without options
				if (skip_travel_type) {
					return;
				}

				if (checkbox.is(":checked") && checkbox.val() === "1") {
					container.find("> div").removeClass("hidden");
				} else {
					container.find("> div").addClass("hidden");
				}

				// load cruise lines
				if (container.hasClass("cruise")) {
					getCruiseLines(true);
					$(".cruise-lines-list select").selectpicker('selectAll');

					getCategoryTypes(true);
				}

				if (container.hasClass("hotel")) {
					getLodgingChains(true);
					$(".lodging-chains-list select").selectpicker('selectAll');

					getAllInclusives(true);
					$(".all-inclusives-list select").selectpicker('selectAll');

					getHotelCountries(true);
					// $(".countries-list select").selectpicker('selectAll');

					getHotelStates(true);
				}

				if (container.hasClass("land")) {
					getTourCompanies(true);
					$(".tourcompanies-list select").selectpicker('selectAll');
				}

				if (container.hasClass("insurance")) {
					getInsuranceCompanies(true);
					$(".insurancecompanies-list select").selectpicker('selectAll');
				}

				if (container.hasClass('transfer')) {
					getTransferCompanies(true);
					$('.transfercompanies-list select').selectpicker('selectAll');
				}

				if (container.hasClass('excursion')) {
					getExcursionCompanies(true);
					$('.excursioncompanies-list select').selectpicker('selectAll');
				}
			});

			// cruise lines
			what_container.on('change', '.what-type .cruise-lines-options', function showCruiseLines()
			{
				var options = $(this).closest(".radio-group").find(".cruise-lines-options");
				options.each(function findChecked()
				{
					toggleSelect($(this), '.cruise-lines-list');
				});
			});

			// hotels
			what_container.on('change', '.what-type .lodging-chains-options', function showLodgingChains()
			{
				var options = $(this).closest(".radio-group").find(".lodging-chains-options");
				options.each(function findChecked()
				{
					toggleSelect($(this), '.lodging-chains-list');
				});
			});

			what_container.on('change', '.what-type .lodging-all-inclusive-options', function showAllInclusive()
			{
				var options = $(this).closest(".radio-group").find(".lodging-all-inclusive-options");
				options.each(function findChecked()
				{
					toggleSelect($(this), '.all-inclusives-list');
				});
			});

			what_container.on('change', '.what-type .lodging-country-options', function showLodgingCountries()
			{
				var options = $(this).closest(".radio-group").find(".lodging-country-options");
				options.each(function findChecked()
				{
					toggleSelect($(this), '.countries-list');
				});
			});

			what_container.on('change', '.what-type .lodging-lodging-names-options', function showLodgingTypeahead()
			{
				var options = $(this).closest(".radio-group").find(".lodging-lodging-names-options");

				options.each(function findChecked()
				{
					if ($(this).is(":checked")) {
						// "All Lodging Chains" is checked
						if ($(this).val() === "1") {
							removeAllSpecificHotels();
							$('.lodging-names-list').addClass("hidden");
						} else {
							$('.lodging-names-list').removeClass("hidden");
						}
					}
				});
			});

			what_container.on('click', '.lodging-names-list .remove', function removeSpecificHotel()
			{
				var $self    = $(this),
				    hotel_id = parseInt($self.data('id'));

				specific_hotels = specific_hotels.filter(function removeItem(item) {
					return parseInt(item.id) !== hotel_id;
				});

				refreshSpecificHotels();
			});

			what_container.on('click', '#remove-all-specific-hotels', function removeAllHotels()
			{
				removeAllSpecificHotels();
			});

			what_container.on('change', '.what-type .lodging-cities-options', function showLodgingCities()
			{
				var options = $(this).closest(".radio-group").find(".lodging-cities-options");
				options.each(function findChecked()
				{
					if ($(this).is(":checked")) {
						if ($(this).val() === "1") {
							$('.lodging-cities-list').addClass("hidden");
						} else {
							$('.lodging-cities-list').removeClass("hidden");
						}
					}
				});
			});

			what_container.on('change', '.what-type .lodging-states-options', function showLodgingCountries()
			{
				var options = $(this).closest(".radio-group").find(".lodging-states-options");
				options.each(function findChecked()
				{
					toggleSelect($(this), '.lodging-states-list');
				});
			});

			// ships
			what_container.on('change', '.what-type .ship-options', function showShips()
			{
				var options = $(this).closest(".radio-group").find(".ship-options");
				options.each(function findChecked()
				{
					toggleSelect($(this), '.ships-list');
				});
			});

			// destinations
			what_container.on('change', '.what-type .destination-options', function showDestinations()
			{
				var options = $(this).closest(".radio-group").find(".destination-options");
				options.each(function findChecked()
				{
					toggleSelect($(this), '.destinations-list');
				});
			});

			// categories
			what_container.on('change', '.what-type .category-options', function showCategories()
			{
				var options = $(this).closest(".radio-group").find(".category-options");
				options.each(function findChecked()
				{
					toggleSelect($(this), '.categories-list');
				});
			});

			// category types
			what_container.on('change', '.what-type .category-type-options', function showCategories()
			{
				var options = $(this).closest(".radio-group").find(".category-type-options");

				options.each(function findChecked()
				{
					toggleSelect($(this), '.category-types-list');
				});
			});

			// tour companies
			what_container.on('change', '.what-type .tourcompany-options', function showTourCompanies()
			{
				var options = $(this).closest(".radio-group").find(".tourcompany-options");
				options.each(function findChecked()
				{
					toggleSelect($(this), '.tourcompanies-list');
				});
			});

			// transfer companies
			what_container.on('change', '.what-type .transfercompany-options', function showTransferCompanies()
			{
				var options = $(this).closest('.radio-group').find('.transfercompany-options');
				options.each(function findChecked()
				{
					toggleSelect($(this), '.transfercompanies-list');
				});
			});

			// excursion companies
			what_container.on('change', '.what-type .excursioncompany-options', function showExcursionCompanies()
			{
				var options = $(this).closest('.radio-group').find('.excursioncompany-options');

				options.each(function findChecked()
				{
					toggleSelect($(this), '.excursioncompanies-list');
				});
			});

			// load ships
			what_container.on('change', '.cruise-lines-list select', function getSelectedValues() {
				var select           = $(this),
				    selected_options = select.find("option:selected");

				cruise_line_ids = [];

				selected_options.each(function getSelectedValues(e)
				{
					var val = $(this).val();
					cruise_line_ids.push(val);
				});

				if (cruise_line_ids.length > 0) {
					getShips(cruise_line_ids, true);
				}
			});

			// load destinations and categories
			what_container.on('change', '.ships-list select', function getSelectedValues() {
				var select           = $(this),
				    selected_options = select.find("option:selected");

				ship_ids = [];

				selected_options.each(function getSelectedValues(e)
				{
					var val = $(this).val();
					ship_ids.push(val);
				});

				if (ship_ids.length > 0) {
					getDestinations(ship_ids, true);
					getCategories(ship_ids, true);
				}
			});

			// "When" Section
			when_container.on('change', '.when_purchases', function showHideDateFields(e) {
				var checkbox  = $(this),
					container = checkbox.closest(".purchases-container");

				container.find("> div").toggleClass("hidden");
			});

			when_container.on('change', '.when_departures', function showHideDateFields(e) {
				var checkbox  = $(this),
					container = checkbox.closest(".departures-container");

				container.find("> div").toggleClass("hidden");
			});

			when_container.on('change', '.when_creations', function showHideDateFields(e) {
				var checkbox  = $(this),
					container = checkbox.closest(".creations-container");

				container.find("> div").toggleClass("hidden");
			});

			// "Display" Section
			display_container.on('change', '.display-view-radio', function showGroupResultsBy()
			{
				var view_type = $(this).val();

				if ($(this).is(':checked')) {
					if (view_type === 'summary') {
						display_container.find('.group-results-by').removeClass("hidden");
						display_container.find('.ho-checkboxes:has(.detail-only)').addClass('hidden');
					} else {
						display_container.find('.group-results-by').addClass("hidden");
						display_container.find('.ho-checkboxes:has(.detail-only)').removeClass('hidden');
					}
				}
			});
			$('.display-view-radio').change();

			// save report logic
			$(".save_this_report").on('change', function toggleDisabledField(e)
			{
				var checkbox = $(this);

				if (checkbox.is(":checked")) {
					$(".save_this_report_name").removeClass("disabled");
					$(".save_this_report_name").removeAttr("disabled");
				} else {
					$(".save_this_report_name").addClass("disabled");
					$(".save_this_report_name").attr("disabled", "disabled");
				}
			});

			checkReload();

			// on load, execute this. it'll check for the session saved stuff as well.
			checkSession();
		});
	});

	function checkSession()
	{
		var url = "/GeneratorReports/checkSavedReportSession";

		Adzuki.Ajax.get(url).then(function executeLoad(response)
		{
			if (response.data_exists === true) {
				loadSavedReport('get session');
			}
		});
	}

	function checkReload()
	{
		var form = $("#reportGeneratorCriteria");

		if (form.find(".what-all-checkbox").is(":checked") === false) {
			form.find(".what-all-checkbox").change();

			if (form.find(".what-type.cruise .what-travel-type").is(":checked") === true) {
				form.find(".what-type.cruise .what-travel-type").change();
			}
			if (form.find(".what-type.land .what-travel-type").is(":checked") === true) {
				form.find(".what-type.land .what-travel-type").change();
			}
			if (form.find(".what-type.insurance .what-travel-type").is(":checked") === true) {
				form.find(".what-type.insurance .what-travel-type").change();
			}
			if (form.find(".what-type.car .what-travel-type").is(":checked") === true) {
				form.find(".what-type.car .what-travel-type").change();
			}
			if (form.find(".what-type.hotel .what-travel-type").is(":checked") === true) {
				form.find(".what-type.hotel .what-travel-type").change();
			}
			if (form.find(".what-type.air .what-travel-type").is(":checked") === true) {
				form.find(".what-type.air .what-travel-type").change();
			}
			if (form.find(".what-type.addons .what-travel-type").is(":checked") === true) {
				form.find(".what-type.addons .what-travel-type").change();
			}
			if (form.find(".what-type.excursion .what-travel-type").is(":checked") === true) {
				form.find(".what-type.excursion .what-travel-type").change();
			}
			if (form.find(".what-type.transfer .what-travel-type").is(":checked") === true) {
				form.find(".what-type.transfer .what-travel-type").change();
			}
			if (form.find(".what-type.attraction .what-travel-type").is(":checked") === true) {
				form.find(".what-type.attraction .what-travel-type").change();
			}
			if (form.find(".what-type.baggage .what-travel-type").is(":checked") === true) {
				form.find(".what-type.baggage .what-travel-type").change();
			}
			if (form.find(".what-type.equipment .what-travel-type").is(":checked") === true) {
				form.find(".what-type.equipment .what-travel-type").change();
			}
			if (form.find(".what-type.event .what-travel-type").is(":checked") === true) {
				form.find(".what-type.event .what-travel-type").change();
			}
			if (form.find(".what-type.parking .what-travel-type").is(":checked") === true) {
				form.find(".what-type.parking .what-travel-type").change();
			}
			if (form.find(".what-type.rail .what-travel-type").is(":checked") === true) {
				form.find(".what-type.rail .what-travel-type").change();
			}
			if (form.find(".what-type.visa .what-travel-type").is(":checked") === true) {
				form.find(".what-type.visa .what-travel-type").change();
			}
		}

		if (form.find(".when_purchases").is(":checked") === true) {
			form.find(".when_purchases").change();
		}

		if (form.find(".when_departures").is(":checked") === true) {
			form.find(".when_departures").change();
		}

		if (form.find(".when_creations").is(":checked") === true) {
			form.find(".when_creations").change();
		}
	}

	function loadSavedReport(saved_report_id)
	{
		var url  = "/GeneratorReports/loadSavedReport/" + saved_report_id;

		loadingScreen('cover');

		Adzuki.Ajax.get(url).then(function success(response) {
			var who               = response.criteria.Who,
				what              = response.criteria.What,
				when              = response.criteria.When,
				display           = response.criteria.Display,
				$what_all_check   = $(".what-all-checkbox"),
				$cruise_check     = $('.what-type.cruise .what-travel-type'),
				$land_check       = $('.what-type.land .what-travel-type'),
				$transfer_check   = $('.what-type.transfer .what-travel-type'),
				$excursion_check  = $('.what-type.excursion .what-travel-type'),
				$insurance_check  = $('.what-type.insurance .what-travel-type'),
				$car_check        = $('.what-type.car .what-travel-type'),
				$hotel_check      = $('.what-type.hotel .what-travel-type'),
				$air_check        = $('.what-type.air .what-travel-type'),
				$addon_check      = $('.what-type.addons .what-travel-type'),
				$attraction_check = $('.what-type.attraction .what-travel-type'),
				$baggage_check    = $('.what-type.baggage .what-travel-type'),
				$equipment_check  = $('.what-type.equipment .what-travel-type'),
				$event_check      = $('.what-type.event .what-travel-type'),
				$parking_check    = $('.what-type.parking .what-travel-type'),
				$rail_check       = $('.what-type.rail .what-travel-type'),
				$visa_check       = $('.what-type.visa .what-travel-type');

			// WHO
			$(".who_type").each(function selectWhoType()
			{
				var radio = $(this);
				if (radio.val() === who.type) {
					radio.attr("checked", "checked");
					radio.closest("label").addClass("active");
				} else {
					radio.removeAttr("checked");
					radio.closest("label").removeClass("active");
				}
			});

			// based on the radio button, show the right form.
			if (who.type === "s") {
				$("#single_franchise_criteria").removeClass("hidden");
				$("#multi_franchise_criteria").addClass("hidden");

				getFranchiseName(who.franchise_id);

				$(".franchise_id").val(who.franchise_id);

				showAgentsForFranchise(who.franchise_id, false, who.agents_ids);
			} else {
				$("#single_franchise_criteria").addClass("hidden");
				$("#multi_franchise_criteria").removeClass("hidden");

				// categories
				$(".who_categories option:selected").removeAttr("selected");
				$(".who_categories").selectpicker('val', who.categories_ids);

				// status
				$(".who_statuses option:selected").removeAttr("selected");
				$(".who_statuses").selectpicker('val', who.status_ids);

				// type
				$(".who_types option:selected").removeAttr("selected");
				$(".who_types").selectpicker('val', who.type_option_ids);

				// region
				$(".who_regions option:selected").removeAttr("selected");
				$(".who_regions").selectpicker('val', who.region_ids);

				// star level
				$(".who_star_levels option:selected").removeAttr("selected");
				$(".who_star_levels").selectpicker('val', who.star_level_ids);

				// incentive level
				$(".who_incentive_levels option:selected").removeAttr("selected");
				$(".who_incentive_levels").selectpicker('val', who.incentive_level_ids);

				// location
				$(".who_locations option:selected").removeAttr("selected");
				$(".who_locations").selectpicker('val', who.state_ids);

				// commencement start date
				$(".commencement-start-date").each(function selectCommencementDateType()
				{
					var radio = $(this);

					if (radio.val() === who.commencement_date_type) {
						radio.attr("checked", "checked");
						radio.closest("label").addClass("active");

						switch (who.commencement_date_type) {
							case "specific":
								$(".commencement-date-specific").removeClass("hidden");
								$(".commencement-date-range").addClass("hidden");
								$(".commencement-date.date").val(who.commencement_date.month + "/" + who.commencement_date.year);
								$(".commencement-date.date").change();
								break;
							case "range":
								$(".commencement-date-specific").addClass("hidden");
								$(".commencement-date-range").removeClass("hidden");
								$(".commencement-date.sdate").val(who.commencement_sdate.month + "/" + who.commencement_sdate.year);
								$(".commencement-date.edate").val(who.commencement_edate.month + "/" + who.commencement_edate.year);
								$(".commencement-date.sdate").change();
								$(".commencement-date.edate").change();
								break;
							default:
								$(".commencement-date-specific").addClass("hidden");
								$(".commencement-date-range").addClass("hidden");
								break;
						}
					} else {
						radio.closest("label").removeClass("active");
						radio.removeAttr("checked");
					}
				});

				// training start date
				$(".training-start-date").each(function selectTrainingDateType()
				{
					var radio = $(this);

					if (radio.val() === who.training_date_type) {
						radio.attr("checked", "checked");
						radio.closest("label").addClass("active");

						switch (who.training_date_type) {
							case "specific":
								$(".training-date-specific").removeClass("hidden");
								$(".training-date-range").addClass("hidden");
								$(".training-date.date").val(who.training_date.month + "/" + who.training_date.year);
								$(".training-date.date").change();
								break;
							case "range":
								$(".training-date-specific").addClass("hidden");
								$(".training-date-range").removeClass("hidden");
								$(".training-date.sdate").val(who.training_sdate.month + "/" + who.training_sdate.year);
								$(".training-date.edate").val(who.training_edate.month + "/" + who.training_edate.year);
								$(".training-date.sdate").change();
								$(".training-date.edate").change();
								break;
							default:
								$(".training-date-specific").addClass("hidden");
								$(".training-date-range").addClass("hidden");
								break;
						}
					} else {
						radio.closest("label").removeClass("active");
						radio.removeAttr("checked");
					}
				});

				loadFranchises(who.franchise_mult_ids);
			}

			// WHAT
			if (what.travel_type_all === "0") {
				$what_all_check.attr("checked", false).trigger('change');

				loaded_what_data = what;

				// cruise
				if (what.travel_type_cruise === "1") {
					$cruise_check.attr("checked", "checked").trigger('change');

					if (what.only_insurance_cruises === "1") {
						$("#reportgenerator-what_only_insurance_cruises").attr("checked", "checked");
					} else {
						$("#reportgenerator-what_only_insurance_cruises").removeAttr("checked");
					}

					$(".cruise-lines-options").each(function selectRadio()
					{
						var on = Boolean($(this).val() === what.all_cruise_lines);
						toggleRadio($(this), on);
					});

					$(".ship-options").each(function selectRadio()
					{
						var on = Boolean($(this).val() === what.all_ships);
						toggleRadio($(this), on);
					});

					$(".category-type-options").each(function selectRadio()
					{
						var on = Boolean($(this).val() === what.all_ship_category_types);
						toggleRadio($(this), on);
					});

					$(".destination-options").each(function selectRadio()
					{
						var on = Boolean($(this).val() === what.all_destinations);
						toggleRadio($(this), on);
					});

					$(".category-options").each(function selectRadio()
					{
						var on = Boolean($(this).val() === what.all_ship_categories);
						toggleRadio($(this), on);
					});
				} else {
					$cruise_check.attr("checked", false).trigger('change');
				}

				// land vacation
				if (what.travel_type_vacation === "1") {
					$land_check.attr("checked", "checked").trigger('change');

					if (what.only_insurance_tours === "1") {
						$("#reportgenerator-what_only_insurance_tours").attr("checked", "checked");
					} else {
						$("#reportgenerator-what_only_insurance_tours").removeAttr("checked");
					}

					$(".tourcompany-options").each(function selectRadio()
					{
						var radio = $(this);

						if (radio.val() === what.all_tour_companies) {
							radio.attr("checked", "checked");
							radio.closest("label").addClass("active");
							radio.change();
							getTourCompanies(false, what.tour_company_ids);
						} else {
							radio.closest("label").removeClass("active");
							radio.removeAttr("checked");
						}
					});
				} else {
					$land_check.attr("checked", false).trigger('change');
				}

				// transfer
				if (what.travel_type_transfer === '1') {
					$transfer_check.attr('checked', 'checked').trigger('change');

					$('.transfercompany-options').each(function selectRadio()
					{
						var radio = $(this);

						if (radio.val() === what.all_transfer_companies) {
							radio.attr('checked', 'checked');
							radio.closest('label').addClass('active');
							radio.change();
							getTransferCompanies(false, what.transfer_company_ids);
						} else {
							radio.closest('label').removeClass('active');
							radio.removeAttr('checked');
						}
					});
				} else {
					$transfer_check.attr('checked', false).trigger('change');
				}

				// excursion
				if (what.travel_type_excursion === '1') {
					$excursion_check.attr('checked', 'checked').trigger('change');

					$('.excursioncompany-options').each(function selectRadio()
					{
						var radio = $(this);

						if (radio.val() === what.all_excursion_companies) {
							radio.attr('checked', 'checked');
							radio.closest('label').addClass('active');
							radio.change();
							getExcursionCompanies(false, what.excursion_company_ids);
						} else {
							radio.closest('label').removeClass('active');
							radio.removeAttr('checked');
						}
					});
				} else {
					$excursion_check.attr('checked', false).trigger('change');
				}

				// insurance
				if (what.travel_type_insurance === "1") {
					$insurance_check.attr("checked", "checked").trigger('change');
					getInsuranceCompanies(false, what.insurance_company_ids);
				} else {
					$insurance_check.attr("checked", false).trigger('change');
				}

				// car
				if (what.travel_type_car === "1") {
					$car_check.attr("checked", "checked").trigger('change');
					$(".what-type.car .radio-group input").each(function selectRadio()
					{
						var on = Boolean($(this).val() === what.car_beach);
						toggleRadio($(this), on);
					});
				} else {
					$car_check.attr("checked", false).trigger('change');
				}

				// hotel
				if (what.travel_type_hotel === "1") {
					$hotel_check.attr("checked", "checked").trigger('change');
					$(".lodging-chains-options").each(function selectRadio(i)
					{
						var on = settingToggle(what.all_lodging_chains, $(this).val(), i);
						toggleRadio($(this), on);
					});

					$(".lodging-all-inclusive-options").each(function selectRadio(i)
					{
						var on = settingToggle(what.all_inclusives, $(this).val(), i);
						toggleRadio($(this), on);
					});

					$(".lodging-country-options").each(function selectRadio(i)
					{
						var on = settingToggle(what.hotel_countries, $(this).val(), i);
						toggleRadio($(this), on);
					});

					$(".lodging-lodging-names-options").each(function selectRadio(i)
					{
						var on = settingToggle(what.lodging_names, $(this).val(), i);
						toggleRadio($(this), on);

						// "Specific Lodging Names" selected
						if ( ($(this).val() === '0') && (on) ) {

							// clear out the specific hotels. logic below will populate them for the saved report if selected
							removeAllSpecificHotels();

							if (what.hotel_ids !== undefined) {
								// need to get hotel names since we only store the ids in `saved_reports`.`criteria`
								Adzuki.Ajax.post('/GeneratorReports/giataHotelLookup/', {
									ids: what.hotel_ids
								}).then(function success(response) {

									$.each(response.hotels, function iterator(i, hotel) {
										specific_hotels.push({
											id  : hotel.id,
											name: hotel.name
										});
									});

									refreshSpecificHotels();
								});
							}
						}
					});

					$(".lodging-states-options").each(function selectRadio(i)
					{
						var on = settingToggle(what.hotel_states, $(this).val(), i);
						toggleRadio($(this), on);
					});

					$(".lodging-cities-options").each(function selectRadio(i)
					{
						var on = settingToggle(what.hotel_cities, $(this).val(), i);
						toggleRadio($(this), on);

						// "Specific Cities" selected
						if ( ($(this).val() === '0') && (on) ) {
							// clear city text field
							$('#reportgenerator-what_travel_type_hotel_cities_text').val('');

							// if we have cities text in the saved report, populate the field
							if (what.hotel_cities_text !== undefined) {
								$('#reportgenerator-what_travel_type_hotel_cities_text').val(what.hotel_cities_text);
							}
						}
					});

				} else {
					$hotel_check.attr("checked", false).trigger('change');
				}

				// air
				if (what.travel_type_air === "1") {
					$air_check.attr("checked", "checked").trigger('change');

					$(".what-type.air .radio-group input").each(function selectRadio()
					{
						var radio = $(this);
						if (radio.val() === what.air_beach) {
							radio.attr("checked", "checked");
							radio.closest("label").addClass("active");
						} else {
							radio.closest("label").removeClass("active");
							radio.removeAttr("checked");
						}
					});
				} else {
					$air_check.attr("checked", false).trigger('change');
				}

				// add ons
				if (what.travel_type_addon === "1") {
					$addon_check.attr("checked", "checked").trigger('change');
				} else {
					$addon_check.attr("checked", false).trigger('change');
				}

				// attraction
				if (what.travel_type_attraction === '1') {
					$attraction_check.attr('checked', 'checked').trigger('change');
				} else {
					$attraction_check.attr('checked', false).trigger('change');
				}

				// baggage
				if (what.travel_type_baggage_service === '1') {
					$baggage_check.attr('checked', 'checked').trigger('change');
				} else {
					$baggage_check.attr('checked', false).trigger('change');
				}

				// equipment rental
				if (what.travel_type_equipment_rental === '1') {
					$equipment_check.attr('checked', 'checked').trigger('change');
				} else {
					$equipment_check.attr('checked', false).trigger('change');
				}

				// event ticket
				if (what.travel_type_event_ticket === '1') {
					$event_check.attr('checked', 'checked').trigger('change');
				} else {
					$event_check.attr('checked', false).trigger('change');
				}

				// parking
				if (what.travel_type_parking === '1') {
					$parking_check.attr('checked', 'checked').trigger('change');
				} else {
					$parking_check.attr('checked', false).trigger('change');
				}

				// rail
				if (what.travel_type_rail === '1') {
					$rail_check.attr('checked', 'checked').trigger('change');
				} else {
					$rail_check.attr('checked', false).trigger('change');
				}

				// visa passport service
				if (what.travel_type_visa_passport_service === '1') {
					$visa_check.attr('checked', 'checked').trigger('change');
				} else {
					$visa_check.attr('checked', false).trigger('change');
				}

			} else {
				$what_all_check.attr("checked", "checked").trigger('change');
			}

			// WHAT: commission supplier type
			$(".commission_supplier_type").each(function selectSupplierType()
			{
				var radio = $(this);

				if (radio.val() === what.commission_supplier_type) {
					radio.attr("checked", "checked");
					radio.closest("label").addClass("active");
				} else {
					radio.closest("label").removeClass("active");
					radio.removeAttr("checked");
				}
			});

			// WHAT: cp status
			$(".what_cp_statuses option:selected").removeAttr("selected");
			$(".what_cp_statuses").selectpicker('val', what.cp_statuses);

			// WHEN
			if (when.purchases === "1") {
				$(".when_purchases").attr("checked", "checked");
				$(".purchases-container > div").removeClass("hidden");
				$("#reportgenerator-when_purchases_sdate").data('DateTimePicker').date(when.purchases_sdate.year + "-" + when.purchases_sdate.month + "-" + when.purchases_sdate.day);
				$("#reportgenerator-when_purchases_edate").data('DateTimePicker').date(when.purchases_edate.year + "-" + when.purchases_edate.month + "-" + when.purchases_edate.day);
				$("#reportgenerator-when_purchases_sdate").change();
				$("#reportgenerator-when_purchases_edate").change();
			} else {
				$(".when_purchases").removeAttr("checked");
				$(".purchases-container > div").addClass("hidden");
			}

			if (when.departures === "1") {
				$(".when_departures").attr("checked", "checked");
				$(".departures-container > div").removeClass("hidden");
				$("#reportgenerator-when_departures_sdate").data('DateTimePicker').date(when.departures_sdate.year + "-" + when.departures_sdate.month + "-" + when.departures_sdate.day);
				$("#reportgenerator-when_departures_edate").data('DateTimePicker').date(when.departures_edate.year + "-" + when.departures_edate.month + "-" + when.departures_edate.day);
				$("#reportgenerator-when_departures_sdate").change();
				$("#reportgenerator-when_departures_edate").change();
			} else {
				$(".when_departures").removeAttr("checked");
				$(".departures-container > div").addClass("hidden");
			}

			if (when.creations === "1") {
				$(".when_creations").attr("checked", "checked");
				$(".creations-container > div").removeClass("hidden");
				$("#reportgenerator-when_creations_sdate").data('DateTimePicker').date(when.creations_sdate.year + "-" + when.creations_sdate.month + "-" + when.creations_sdate.day);
				$("#reportgenerator-when_creations_edate").data('DateTimePicker').date(when.creations_edate.year + "-" + when.creations_edate.month + "-" + when.creations_edate.day);
				$("#reportgenerator-when_creations_sdate").change();
				$("#reportgenerator-when_creations_edate").change();
			} else {
				$(".when_creations").removeAttr("checked");
				$(".creations-container > div").addClass("hidden");
			}

			// DISPLAY
			$(".display-view-radio").each(function selectView()
			{
				var radio = $(this);
				if (radio.val() === display.view) {
					radio.attr("checked", "checked");
					radio.closest("label").addClass("active");
				} else {
					radio.closest("label").removeClass("active");
					radio.removeAttr("checked");
				}
			});

			$(".display-group-by").each(function selectGroup()
			{
				var radio = $(this);
				if (radio.val() === display.group_by) {
					radio.attr("checked", "checked");
					radio.closest("label").addClass("active");
				} else {
					radio.closest("label").removeClass("active");
					radio.removeAttr("checked");
				}
			});

			if (display.view === "summary") {
				$('.group-results-by').removeClass("hidden");
			}

			if (display.breakout_additional_components === "1") {
				$("#reportgenerator-display_breakout_additional_components").attr("checked", "checked");
			} else {
				$("#reportgenerator-display_breakout_additional_components").removeAttr("checked");
			}

			// checkboxes
			if (display.total_sales === "1") {
				$("#reportgenerator-display_total_sales").attr("checked", "checked");
			} else {
				$("#reportgenerator-display_total_sales").removeAttr("checked");
			}

			if (display.incentive_sales === "1") {
				$("#reportgenerator-display_incentive_sales").attr("checked", "checked");
			} else {
				$("#reportgenerator-display_incentive_sales").removeAttr("checked");
			}

			if (display.suppress_zeros === "1") {
				$("#reportgenerator-display_suppress_zeros").attr("checked", "checked");
			} else {
				$("#reportgenerator-display_suppress_zeros").removeAttr("checked");
			}

			if (display.franchise_data_split_agent_names === "1") {
				$("#reportgenerator-display_franchise_data_split_agent_names").attr("checked", "checked");
			} else {
				$("#reportgenerator-display_franchise_data_split_agent_names").removeAttr("checked");
			}

			if (display.franchise_data_id === "1") {
				$("#reportgenerator-display_franchise_data_id").attr("checked", "checked");
			} else {
				$("#reportgenerator-display_franchise_data_id").removeAttr("checked");
			}

			if (display.franchise_data_contract_id === "1") {
				$("#reportgenerator-display_franchise_data_contract_id").attr("checked", "checked");
			} else {
				$("#reportgenerator-display_franchise_data_contract_id").removeAttr("checked");
			}

			if (display.franchise_data_recognition_name === "1") {
				$("#reportgenerator-display_franchise_data_recognition_name").attr("checked", "checked");
			} else {
				$("#reportgenerator-display_franchise_data_recognition_name").removeAttr("checked");
			}

			if (display.franchise_data_email_address === "1") {
				$("#reportgenerator-display_franchise_data_email_address").attr("checked", "checked");
			} else {
				$("#reportgenerator-display_franchise_data_email_address").removeAttr("checked");
			}

			if (display.franchise_data_phone_number === "1") {
				$("#reportgenerator-display_franchise_data_phone_number").attr("checked", "checked");
			} else {
				$("#reportgenerator-display_franchise_data_phone_number").removeAttr("checked");
			}

			if (display.franchise_data_type === "1") {
				$("#reportgenerator-display_franchise_data_type").attr("checked", "checked");
			} else {
				$("#reportgenerator-display_franchise_data_type").removeAttr("checked");
			}

			if (display.franchise_data_category === "1") {
				$("#reportgenerator-display_franchise_data_category").attr("checked", "checked");
			} else {
				$("#reportgenerator-display_franchise_data_category").removeAttr("checked");
			}

			if (display.franchise_data_status === "1") {
				$("#reportgenerator-display_franchise_data_status").attr("checked", "checked");
			} else {
				$("#reportgenerator-display_franchise_data_status").removeAttr("checked");
			}

			if (display.franchise_data_location === "1") {
				$("#reportgenerator-display_franchise_data_location").attr("checked", "checked");
			} else {
				$("#reportgenerator-display_franchise_data_location").removeAttr("checked");
			}

			if (display.franchise_data_address === "1") {
				$("#reportgenerator-display_franchise_data_address").attr("checked", "checked");
			} else {
				$("#reportgenerator-display_franchise_data_address").removeAttr("checked");
			}

			if (display.franchise_data_commencement_date === "1") {
				$("#reportgenerator-display_franchise_data_commencement_date").attr("checked", "checked");
			} else {
				$("#reportgenerator-display_franchise_data_commencement_date").removeAttr("checked");
			}

			if (display.franchise_data_training_date === "1") {
				$("#reportgenerator-display_franchise_data_training_date").attr("checked", "checked");
			} else {
				$("#reportgenerator-display_franchise_data_training_date").removeAttr("checked");
			}

			if (display.franchise_data_region === "1") {
				$("#reportgenerator-display_franchise_data_region").attr("checked", "checked");
			} else {
				$("#reportgenerator-display_franchise_data_region").removeAttr("checked");
			}

			if (display.franchise_data_star_level === "1") {
				$("#reportgenerator-display_franchise_data_star_level").attr("checked", "checked");
			} else {
				$("#reportgenerator-display_franchise_data_star_level").removeAttr("checked");
			}

			if (display.franchise_data_incentive_level === "1") {
				$("#reportgenerator-display_franchise_data_incentive_level").attr("checked", "checked");
			} else {
				$("#reportgenerator-display_franchise_data_incentive_level").removeAttr("checked");
			}

			if (display.franchise_data_termination_date === "1") {
				$("#reportgenerator-display_franchise_data_termination_date").attr("checked", "checked");
			} else {
				$("#reportgenerator-display_franchise_data_termination_date").removeAttr("checked");
			}

			if (display.surppress_bookings_with_no_money === "1") {
				$("#reportgenerator-display_surppress_bookings_with_no_money").attr("checked", "checked");
			} else {
				$("#reportgenerator-display_surppress_bookings_with_no_money").removeAttr("checked");
			}

			// Save as option
			if (response.id) {
				$('.save_this_report_name').val(response.name);
				$('.save_this_report').on('change', function onSaveReportChange(event)
				{
					if ($(this).is(':checked')) {
						$('.replace-report').removeClass('hidden');
					} else {
						$('.replace-report').addClass('hidden');
					}
				});
			}

			$(".display-view-radio").change();
			loadingScreen('reveal');
		});
	}

	function getAgents()
	{
		var url = "/GeneratorReports/getAgents";
		Adzuki.Ajax.get(url).then(function success(response) {
			var results        = response.results,
				select_options = results;

			$("#reportgenerator-agent_ids").html(select_options);
			$("#reportgenerator-agent_ids").selectpicker('refresh');
		});
	}

	function getCruiseLines(selectAll)
	{
		var url                  = "/GeneratorReports/getCruiseLines",
			selectAllCruises     = selectAll || false;

		Adzuki.Ajax.get(url).then(function success(response) {
			var results        = response.cruiselines;

			$(".cruise-lines-list select").html(results);
			$(".cruise-lines-list select").selectpicker('refresh');

			// passed data
			if (loaded_what_data.all_cruise_lines === "0") {
				$(".cruise-lines-list select").selectpicker('val', loaded_what_data.cruise_line_ids);
				selectAllCruises = false;
				$(".cruise-lines-list").removeClass("hidden");
			}

			if (selectAllCruises) {
				$(".cruise-lines-list select").selectpicker('selectAll');
			}

			getShips($(".cruise-lines-list select").val(), true);
		});
	}

	function getShips(cruise_line_ids, selectAll)
	{
		var url            = "/GeneratorReports/getShips",
			selectAllShips = selectAll || false;

		Adzuki.Ajax.post(url, {
			cruise_lines: cruise_line_ids
		}).then(function success(response) {
			var results = response.ships;

			$(".ships-list select").html(results);
			$(".ships-list select").selectpicker('refresh');

			// passed data
			if (loaded_what_data.all_ships === "0") {
				$(".ships-list select").selectpicker('val', loaded_what_data.ship_ids);
				selectAllShips = false;
				$(".ships-list").removeClass("hidden");
			}

			if (selectAllShips) {
				$(".ships-list select").selectpicker('selectAll');
			}

			// load destinations and categories
			getDestinations($(".ships-list select").val(), true);
			getCategories($(".ships-list select").val(), true);
		});
	}

	function getDestinations(ship_ids, selectAll) {
		var url                   = "/GeneratorReports/getDestinations",
			selectAllDestinations = selectAll || false;

		Adzuki.Ajax.post(url, {
			ships: ship_ids
		}).then(function success(response) {
			var results = response.destinations;

			$(".destinations-list select").html(results);
			$(".destinations-list select").selectpicker('refresh');

			// passed data
			if (loaded_what_data.all_destinations === "0") {
				$(".destinations-list select").selectpicker('val', loaded_what_data.destination_ids);
				selectAllDestinations = false;
				$(".destinations-list").removeClass("hidden");
			}

			if (selectAllDestinations) {
				$(".destinations-list select").selectpicker('selectAll');
			}
		});
	}

	function getCategories(ship_ids, selectAll) {
		var url                 = "/GeneratorReports/getCategories",
			selectAllCategories = selectAll || false;

		Adzuki.Ajax.post(url, {
			ships: ship_ids
		}).then(function success(response) {
			var results = response.categories;

			$(".categories-list select").html(results);
			$(".categories-list select").selectpicker('refresh');

			// passed data
			if (loaded_what_data.all_ship_categories === "0") {
				$(".categories-list select").selectpicker('val', loaded_what_data.ship_category_ids);
				selectAllCategories = false;
				$(".categories-list").removeClass("hidden");
			}

			if (selectAllCategories) {
				$(".categories-list select").selectpicker('selectAll');
			}
		});
	}

	function getCategoryTypes(selectAll)
	{
		var selectAllCts = selectAll || false;
		// passed data
		if (loaded_what_data.all_ship_category_types === "0") {
			$(".category-types-list select").selectpicker('val', loaded_what_data.ship_category_types);
			selectAllCts = false;
			$(".category-types-list").removeClass("hidden");
		}

		if (selectAllCts) {
			$(".category-types-list select").selectpicker('selectAll');
		}
	}

	function getAllInclusives(selectAll)
	{
		var url             = "/GeneratorReports/getAllInclusives",
			selectAllChains = selectAll || false;

		Adzuki.Ajax.get(url).then(function success(response) {
			var results = response.all_inclusives;

			$(".all-inclusives-list select").html(results);
			$(".all-inclusives-list select").selectpicker('refresh');

			// passed data
			if (loaded_what_data.all_inclusives === "0") {
				$(".all-inclusives-list select").selectpicker('val', loaded_what_data.all_inclusive_ids);
				selectAllChains = false;
				$(".all-inclusives-list").removeClass("hidden");
			}

			if (selectAllChains) {
				$(".all-inclusives-list select").selectpicker('selectAll');
			}
		});
	}

	function getHotelCountries(selectAll)
	{
		var selectAllChains = selectAll || false;
		// passed data
		if (loaded_what_data.hotel_countries === "0") {
			$(".countries-list select").selectpicker('val', loaded_what_data.hotel_country_ids);
			selectAllChains = false;
			$(".countries-list").removeClass("hidden");
		}

		if (selectAllChains) {
			$(".countries-list select").selectpicker('selectAll');
		}
	}

	function getLodgingChains(selectAll)
	{
		var url             = "/GeneratorReports/getLodgingChains",
			selectAllChains = selectAll || false;

		Adzuki.Ajax.get(url).then(function success(response) {
			var results = response.lodging_chains;

			$(".lodging-chains-list select").html(results);
			$(".lodging-chains-list select").selectpicker('refresh');

			// passed data
			if (loaded_what_data.all_lodging_chains === "0") {
				$(".lodging-chains-list select").selectpicker('val', loaded_what_data.lodging_chain_ids);
				selectAllChains = false;
				$(".lodging-chains-list").removeClass("hidden");
			}

			if (selectAllChains) {
				$(".lodging-chains-list select").selectpicker('selectAll');
			}
		});
	}

	function getHotelStates(selectAll)
	{
		var selectAllChains = selectAll || false;
		// passed data
		if (loaded_what_data.hotel_states === "0") {
			$(".lodging-states-list select").selectpicker('val', loaded_what_data.hotel_state_ids);
			selectAllChains = false;
			$(".lodging-states-list").removeClass("hidden");
		}

		if (selectAllChains) {
			$(".lodging-states-list select").selectpicker('selectAll');
		}
	}

	function getTourCompanies(selectAll, selectedValues) {
		var url                       = "/GeneratorReports/getTourCompanies",
			selectAllCompanies        = selectAll || false,
			selectedTourCompanyValues = selectedValues || false;

		Adzuki.Ajax.get(url).then(function success(response) {
			var results = response.tourcompanies;

			$(".tourcompanies-list select").html(results);
			$(".tourcompanies-list select").selectpicker('refresh');

			if (selectedTourCompanyValues) {
				$(".tourcompanies-list select").selectpicker('val', selectedTourCompanyValues);
			}

			if (selectAllCompanies) {
				$(".tourcompanies-list select").selectpicker('selectAll');
			}
		});
	}

	function getInsuranceCompanies(selectAll, selectedValues) {
		var url                     = "/GeneratorReports/getInsuranceCompanies",
			selectAllCompanies      = selectAll || false,
			selectedInsuranceValues = selectedValues || false;

		Adzuki.Ajax.get(url).then(function success(response) {
			var results = response.insurancecompanies;

			$(".insurancecompanies-list select").html(results);
			$(".insurancecompanies-list select").selectpicker('refresh');

			if (selectedInsuranceValues) {
				$(".insurancecompanies-list select").selectpicker('val', selectedInsuranceValues);
			}

			if (selectAllCompanies) {
				$(".insurancecompanies-list select").selectpicker('selectAll');
			}
		});
	}

	function getTransferCompanies(selectAll, selectedValues)
	{
		var url                    = '/GeneratorReports/getTransferCompanies';
		var selectAllCompanies     = selectAll || false;
		var selectedTransferValues = selectedValues || false;

		Adzuki.Ajax.get(url).then(function success(response) {
			var results = response.transfercompanies;

			$('.transfercompanies-list select').html(results);
			$('.transfercompanies-list select').selectpicker('refresh');

			if (selectedTransferValues) {
				$('.transfercompanies-list select').selectpicker('val', selectedTransferValues);
			}

			if (selectAllCompanies) {
				$('.transfercompanies-list select').selectpicker('selectAll');
			}
		});
	}

	function getExcursionCompanies(selectAll, selectedValues)
	{
		var url                    = '/GeneratorReports/getExcursionCompanies';
		var selectAllCompanies     = selectAll || false;
		var selectedExcursionValues = selectedValues || false;

		Adzuki.Ajax.get(url).then(function success(response) {
			var results = response.excursioncompanies;

			$('.excursioncompanies-list select').html(results);
			$('.excursioncompanies-list select').selectpicker('refresh');

			if (selectedExcursionValues) {
				$('.excursioncompanies-list select').selectpicker('val', selectedExcursionValues);
			}

			if (selectAllCompanies) {
				$('.excursioncompanies-list select').selectpicker('selectAll');
			}
		});
	}

	function showAgentsForFranchise(franchise_id, selectAll, selectedValues) {
		var url                     = "/GeneratorReports/getAgentsForFranchise/" + franchise_id;
			// selectAllFranchises     = selectAll || false,
			// selectedFranchiseValues = selectedValues || false;


		Adzuki.Ajax.get(url).then(function success(response) {
			var results = response.agents,
				agents_list = $(".agent_ids");

			agents_list.find('select').html(results);
			agents_list.selectpicker('refresh');
			agents_list.closest(".row").removeClass("hidden");
		});
	}

	function loadingScreen(showOrNo)
	{
		var form     = $("#reportGeneratorCriteria"),
			sections = form.find(".box");

		sections.each(function greyOut()
		{
			var box     = $(this),
				loader  = box.find(".loading-content");

			switch (showOrNo) {
				case "cover":
					box.addClass('hide-content');
					loader.removeClass('hidden');
					break;
				case "reveal":
				default:
					box.removeClass('hide-content');
					loader.addClass('hidden');
					break;
			}
		});
	}

	function getFranchiseName(franchise_id)
	{
		var url = "/GeneratorReports/getFranchiseName/" + franchise_id;

		Adzuki.Ajax.get(url).then(function printFranchiseName(response)
		{
			$(".who_franchise_search").val(response.display);
		});
	}

	function loadFranchises(franchise_mult_ids)
	{
		var categories             = $(".who_categories").val(),
			statuses               = $(".who_statuses").val(),
			types                  = $(".who_types").val(),
			star_levels            = $(".who_star_levels").val(),
			franchise_regions      = $(".who_regions").val(),
			incentive_levels       = $(".who_incentive_levels").val(),
			locations              = $(".who_locations").val(),
			commencement_date_type = $(".commencement-start-date:checked").val(),
			commencement_dates     = {},
			training_date_type     = $(".training-start-date:checked").val(),
			training_dates         = {},
			franchise_type         = null,
			url                    = '/GeneratorReports/getFranchiseListByCriteria/';

		switch (commencement_date_type) {
			case "specific":
				commencement_dates = {
					specific: {
						date: $(".commencement-date.date").val()
					}
				};
				break;
			case "range":
				commencement_dates = {
					range: {
						sdate: $(".commencement-date.sdate").val(),
						edate: $(".commencement-date.edate").val()
					}
				};
				break;
			default:
				break;
		}

		switch (training_date_type) {
			case "specific":
				training_dates = {
					specific: {
						date: $(".training-date.date").val()
					}
				};
				break;
			case "range":
				training_dates = {
					range: {
						sdate: $(".training-date.sdate").val(),
						edate: $(".training-date.edate").val()
					}
				};
				break;
			default:
				break;
		}

		$('.who_type').each(function onEachWhoType(i, elem)
		{
			if ($(elem).is(':checked')) {
				franchise_type = $(elem).val();
				return false;
			}
		});

		if (load_franchises_jqxhr !== null) {
			console.log(load_franchises_jqxhr);

			load_franchises_jqxhr.abort();

			load_franchises_jqxhr = null;
		}
		
		loadingScreen('cover');

		load_franchises_jqxhr = Adzuki.Ajax.post(url, {
			type                  : franchise_type,
			category_id           : categories,
			status_id             : statuses,
			type_option_id        : types,
			star_level_id         : star_levels,
			region_id             : franchise_regions,
			incentive_level_id    : incentive_levels,
			commencement_date_type: commencement_dates,
			training_date_type    : training_dates,
			state_id              : locations,
		});

		load_franchises_jqxhr.then(function success(response)
		{
			var results = response.franchises;

			$("select.who_franchise_mult_ids").html(results);
			$(".who_franchise_mult_ids").selectpicker('refresh');

			if (franchise_mult_ids) {
				$(".who_franchise_mult_ids").selectpicker('val', franchise_mult_ids);
			} else {
				$(".who_franchise_mult_ids").selectpicker('selectAll');
			}

			loadingScreen('reveal');
		});
	}

	function refreshSpecificHotels()
	{
		var html           = '',
		    traveler_count = 1;

		if (specific_hotels.length > 0) {
			html += '<span class="recipient remove-all" id="remove-all-specific-hotels">';
			html += '	<span data-toggle="tooltip" data-placement="right" title="" data-original-title="Remove All">';
			html += '		<i class="' + Adzuki.FaIcon.getIconStyle('delete') + '"></i>';
			html += '	</span>';
			html += '</span>';

			$.each(specific_hotels, function iterator(i, hotel) {
				html += '<span class="recipient">';
				html += '	<span class="remove" data-id="' + hotel.id + '" data-name="' + hotel.name + '"><i class="fas fa-times"></i></span>';
				html += '	<span class="title"><strong>Hotel ' + traveler_count + ':</strong> ' + hotel.name + '</span>';
				html += '	<input type="hidden" name="form_component_data[ReportGenerator][what_travel_type_hotel_specific_hotels][]" value="' + hotel.id + '">';
				html += '</span>';

				traveler_count++;
			});
		}

		$('.lodging-names-list .recipients').html(html);
	}

	function removeAllSpecificHotels()
	{
		specific_hotels = [];
		refreshSpecificHotels();
	}

	/**
	 * should radio be on or off
	 * @param  mixed setting      setting value from the DB if it exists
	 * @param  bool  radio_val    value of radio input
	 * @param  int   iteration    what iteration of the loop over the radio buttons?
	 * @return bool
	 */
	function settingToggle(setting, radio_val, iteration)
	{
		var on = false;

		// if nothing saved for this setting in the DB and it's the first radio, default to checked
		if ((setting === undefined) && (iteration === 0)) {
			on = true;
		// setting value equals radio value
		} else if (radio_val === setting) {
			on = true;
		}

		return on;
	}

	// make radio button checked or not
	function toggleRadio(radio, on)
	{
		if (on === true) {
			radio.closest("label").addClass("active");
			radio.prop('checked', true).trigger("change");
		} else {
			radio.closest("label").removeClass("active");
			radio.prop('checked', false);
		}
	}

	// determines whether to show corresponding drop-down with specific options or hide it
	function toggleSelect(option, css_class)
	{
		if (option.is(":checked")) {
			if (option.val() === "1") {
				// select "all" and hide drop-down list
				$(css_class).addClass("hidden");
				$(css_class + " select").selectpicker('selectAll');
			} else {
				// show list and allow user to select specific ones
				$(css_class).removeClass("hidden");
			}
		}
	}
}(jQuery, window.Adzuki || {}));
